import React, { useState } from 'react';

import { Link, useNavigate } from 'react-router-dom';

import Swal from 'sweetalert2';

import { FaBullseye } from 'react-icons/fa';

import Title from '../../Components/Admin/Title';
import { PURPOSE_DATA_INSERT_ADMIN_URL } from '../../utils/Constant';
import { authHeaders } from '../../utils/api';

function CreatePurpose() {

    const navigate = useNavigate();

    // =========================
    // FORM DATA
    // =========================

    const [formData, setFormData] = useState({
        name: '',
        status: '1',
    });

    // =========================
    // ERRORS
    // =========================

    const [errors, setErrors] = useState({});

    // =========================
    // VALIDATION
    // =========================

    const validateErrors = (name, value) => {

        let error = '';

        if (
            value === '' ||
            value === null ||
            value === undefined
        ) {

            error = 'This field is required';
        }

        return error;
    };

    // =========================
    // HANDLE CHANGE
    // =========================

    const handleChange = (e) => {

        const { name, value } = e.target;

        const updatedData = {
            ...formData,
            [name]: value,
        };

        setFormData(updatedData);

        const error = validateErrors(name, value);

        setErrors((prev) => ({
            ...prev,
            [name]: error,
        }));
    };

    // =========================
    // FORM VALIDATE
    // =========================

    const formValidate = () => {

        const tempErrors = {};

        Object.keys(formData).forEach((key) => {

            const error = validateErrors(
                key,
                formData[key]
            );

            if (error) {

                tempErrors[key] = error;
            }
        });

        setErrors(tempErrors);

        return Object.keys(tempErrors).length === 0;
    };

    // =========================
    // SUBMIT
    // =========================

    const handleSubmit = async (e) => {

        e.preventDefault();

        const isValid = formValidate();

        if (!isValid) return;

        try {

            const res = await fetch(
                PURPOSE_DATA_INSERT_ADMIN_URL,
                {
                    method: 'POST',

                    headers: {
                        ...authHeaders(),
                    },

                    body: JSON.stringify(formData),
                }
            );

            const data = await res.json();

            if (!res.ok) {

                Swal.fire({
                    icon: 'error',
                    title: 'Oops!',
                    text: data.message || 'Something went wrong',
                });

                return;
            }

            Swal.fire({
                icon: 'success',
                title: 'Success',
                text: data.message,
                timer: 2000,
                showConfirmButton: false,
            });

            setTimeout(() => {

                navigate('/admin/purposes');

            }, 2000);

        } catch (error) {

            console.log(error);
        }
    };

    return (
        <>

            <Title
                icon={FaBullseye}
                title='Create Purpose'
            />

            <div className="bg-white rounded shadow-lg mt-5">

                <h4 className="text-lg p-4 font-semibold border-b flex justify-between items-center">

                    Add Purpose

                    <Link
                        to="/admin/purposes"
                        className='btn btn-accent btn-sm text-white shadow-md'
                    >
                        Back
                    </Link>

                </h4>

                <form
                    onSubmit={handleSubmit}
                    className="p-4"
                >

                    <div className="grid grid-cols-2 gap-5">

                        {/* NAME */}
                        <div>

                            <label className="block text-sm mb-1">
                                Name
                                <span className="text-red-500"> *</span>
                            </label>

                            <input
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                className={`
                                    input
                                    input-bordered
                                    w-full
                                    ${errors.name ? 'border-error' : ''}
                                `}
                            />

                            {errors.name && (
                                <p className="text-red-500 text-xs mt-1">
                                    {errors.name}
                                </p>
                            )}

                        </div>

                        {/* STATUS */}
                        <div>

                            <label className="block text-sm mb-1">
                                Status
                                <span className="text-red-500"> *</span>
                            </label>

                            <select
                                name="status"
                                value={formData.status}
                                onChange={handleChange}
                                className={`
                                    select
                                    select-bordered
                                    w-full
                                    ${errors.status ? 'border-error' : ''}
                                `}
                            >

                                <option value="1">
                                    Active
                                </option>

                                <option value="0">
                                    Inactive
                                </option>

                            </select>

                            {errors.status && (
                                <p className="text-red-500 text-xs mt-1">
                                    {errors.status}
                                </p>
                            )}

                        </div>

                    </div>

                    {/* BUTTON */}

                    <div className="mt-5 flex gap-3">

                        <button
                            type="submit"
                            className="btn btn-success text-white"
                        >
                            Save
                        </button>

                        <Link
                            to="/admin/purposes"
                            className="btn btn-secondary text-white"
                        >
                            Cancel
                        </Link>

                    </div>

                </form>

            </div>

        </>
    )
}

export default CreatePurpose